var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11473_81141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11473_81141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4154 11.5834L12.207 10.375C12.332 9.72226 12.1445 9.11115 11.6445 8.54171C11.1445 7.97226 10.4987 7.75004 9.70703 7.87504L8.4987 6.66671C8.73481 6.5556 8.97439 6.47226 9.21745 6.41671C9.4605 6.36115 9.72092 6.33337 9.9987 6.33337C11.0404 6.33337 11.9258 6.69796 12.6549 7.42712C13.3841 8.15629 13.7487 9.04171 13.7487 10.0834C13.7487 10.3612 13.7209 10.6216 13.6654 10.8646C13.6098 11.1077 13.5265 11.3473 13.4154 11.5834ZM16.082 14.2084L14.8737 13.0417C15.4015 12.6389 15.8702 12.198 16.2799 11.7188C16.6897 11.2396 17.0404 10.6945 17.332 10.0834C16.6376 8.6806 15.6411 7.56601 14.3424 6.73962C13.0438 5.91324 11.5959 5.50004 9.9987 5.50004C9.59592 5.50004 9.20009 5.52782 8.8112 5.58337C8.42231 5.63893 8.04036 5.72226 7.66536 5.83337L6.3737 4.54171C6.94314 4.3056 7.52648 4.12851 8.1237 4.01046C8.72092 3.8924 9.34592 3.83337 9.9987 3.83337C12.0959 3.83337 13.964 4.41324 15.6029 5.57296C17.2418 6.73268 18.4293 8.23615 19.1654 10.0834C18.8459 10.9028 18.4258 11.6632 17.9049 12.3646C17.3841 13.066 16.7765 13.6806 16.082 14.2084ZM16.4987 19.3334L12.9987 15.875C12.5126 16.0278 12.023 16.1424 11.5299 16.2188C11.0369 16.2952 10.5265 16.3334 9.9987 16.3334C7.90148 16.3334 6.03342 15.7535 4.39453 14.5938C2.75564 13.4341 1.56814 11.9306 0.832031 10.0834C1.1237 9.34726 1.49175 8.66324 1.9362 8.03129C2.38064 7.39935 2.88759 6.83337 3.45703 6.33337L1.16536 4.00004L2.33203 2.83337L17.6654 18.1667L16.4987 19.3334ZM4.6237 7.50004C4.22092 7.86115 3.85286 8.25699 3.51953 8.68754C3.1862 9.1181 2.90148 9.58337 2.66536 10.0834C3.35981 11.4862 4.35634 12.6007 5.65495 13.4271C6.95356 14.2535 8.40148 14.6667 9.9987 14.6667C10.2765 14.6667 10.5473 14.6493 10.8112 14.6146C11.0751 14.5799 11.3459 14.5417 11.6237 14.5L10.8737 13.7084C10.7209 13.75 10.5751 13.7813 10.4362 13.8021C10.2973 13.823 10.1515 13.8334 9.9987 13.8334C8.95703 13.8334 8.07161 13.4688 7.34245 12.7396C6.61328 12.0105 6.2487 11.125 6.2487 10.0834C6.2487 9.9306 6.25911 9.78476 6.27995 9.64587C6.30078 9.50699 6.33203 9.36115 6.3737 9.20837L4.6237 7.50004Z",
    fill: "#878A93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.e74f1735437adf79d85a60ec2564d28a.svg";
export { ForwardRef as ReactComponent };